import { __ } from '@wordpress/i18n';

export const normalSettings = {
  theme: 'relax'
};

export const notyThemes = [
  {label: __( 'Relax', 'buba-blocks' ), value: 'relax'},
  {label: __( 'Sunset', 'buba-blocks' ), value: 'seunset'},
  {label: __( 'Mint', 'buba-blocks' ), value: 'mint'},
  {label: __( 'Light', 'buba-blocks' ), value: 'light'},
  {label: __( 'Bootstrap V3', 'buba-blocks' ), value: 'bootstrap-v3'},
  {label: __( 'Bootstrap V4', 'buba-blocks' ), value: 'bootstrap-v4'},
  {label: __( 'Metro UI', 'buba-blocks' ), value: 'metroui'},
  {label: __( 'Nest', 'buba-blocks' ), value: 'nest'},
  {label: __( 'Semantic UI', 'buba-blocks' ), value: 'semanticui'}
];